export const SET_SELECTED_HR_NOTIFICATION = 'SET_SELECTED_HR_NOTIFICATION';
